import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const loop: AdminBlockTypeAttribute = {
  label: 'Carousel loop',
  key: 'loop',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default loop;
